// @flow

import React from 'react';
import type { WeightedSpendPotentialBL2Bean } from '../../../../types/apolloType';
import Loader from '../../../common/Loader';
import WeightedSpendPotentialGraph from './components/WeightedSpendPotentialGraph';
import marketingApi from '../../../../network/api/marketingApi';
import MarketingEmptyTile from './MarketingEmptyTile';
import type { ShoppingCenter } from '../../../../types/shoppingCenterType';

type Props = {
  shoppingCenter: ShoppingCenter,
}
type State = {
  weightedSpend: WeightedSpendPotentialBL2Bean[],
  isLoading: boolean,
}

class WeightedSpendPotential extends React.Component<Props, State> {
  state: State = {
    isLoading: true,
    weightedSpend: [],
  }

  componentDidMount() {
    marketingApi.fetchWeightedSpend(this.props.shoppingCenter.id)
      .then(response => response.json())
      .then(response => this.setState({
        weightedSpend: response,
      }))
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  }

  render() {
    if (this.state.isLoading) {
      return (
        <Loader isLoading />
      );
    }
    if (!this.state.weightedSpend || this.state.weightedSpend.length < 1) {
      return (
        <MarketingEmptyTile errorMessage="MKT_PAGE.NO_DATA_CACI" />
      );
    }
    return (
      <div className="weighted-spend-potential">
        <WeightedSpendPotentialGraph
          data={this.state.weightedSpend}
        />
      </div>
    );
  }
}

export default WeightedSpendPotential;
